module.exports = __webpack_public_path__ + "img/BAU Seniors_30.bfb3dd57.jpg";